module.exports = __webpack_public_path__ + "media/images/area/icon_weather_6-96f467cff78d2756beee8f3eb8966b5a.png";